const SIGN_TYPES = new Set(["ELECTRONICA", "DIGITAL"]);

export const EMPTY_SIGNER_ACTIONS = Object.freeze({
  puedeFirmar: false,
  puedeRechazar: false,
  tipoFirma: null,
});

export const normalizeSignerActions = (data) => ({
  puedeFirmar: data?.puedeFirmar === true,
  puedeRechazar: data?.puedeRechazar === true,
  tipoFirma: SIGN_TYPES.has(data?.tipoFirma) ? data.tipoFirma : null,
});

const getSignerActions = async (axiosInstance, documentId) => {
  if (!documentId) {
    throw new Error("El id del documento es obligatorio para consultar sus acciones.");
  }

  const endpoint = process.env.REACT_APP_SIGNER_ACTIONS;
  if (!endpoint) {
    throw new Error("REACT_APP_SIGNER_ACTIONS no está configurada.");
  }

  const response = await axiosInstance.get(
    `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
    {
      params: { id: documentId },
      timeout: 20000,
    }
  );

  return normalizeSignerActions(response.data);
};

export default getSignerActions;
